import { Box, Text } from '@chakra-ui/core'
import { StyledFormControl, StyledFormLabel } from 'components/AdminConsole/commonUI/styles'
import { SelectionMode } from 'components/CommonComponents/OptimizedGroupsTree/hooks/useSelection'
import { PreviewAvatarsList } from 'components/CommonComponents/PreviewList'
import TagsList from 'components/CommonComponents/TagsList'
import useLocaleText from 'components/useLocaleText'
import { RootState } from 'constants/interfaces'
import { FolderRoot, Tag } from 'lucide-react'
import React, { useMemo } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useSelector } from 'react-redux'

const listHeight = 250

export const CampaignTags = () => {
  const { control, setValue, watch } = useFormContext()
  const { tags: configTags } = useSelector((state: RootState) => state.config.config)
  const t_tag = useLocaleText('tag', true)
  const t_selected_tag = useLocaleText('selected_tag', true)
  const slectedTagId = watch('tag_id')

  const tags = useMemo(() => {
    return configTags.filter((tag) => tag.sk === slectedTagId)
  }, [configTags, slectedTagId])

  const handleTagsSelectionChange = (ids: string[]) => {
    setValue('tag_id', ids[0], true)
  }
  return (
    <StyledFormControl>
      <StyledFormLabel mt={4}>
        <FolderRoot size={18} strokeWidth={2.5} />
        <Text>{t_tag}</Text>
      </StyledFormLabel>
      <StyledFormControl mb={2}>
        <PreviewAvatarsList
          icon={Tag}
          label={t_selected_tag}
          items={
            slectedTagId
              ? tags.map((tag) => ({
                  name: tag?.name || '',
                }))
              : []
          }
          defaultValue="-"
          max={10}
          isGroup
        />
      </StyledFormControl>
      <Box borderRadius="5px" bg="white" padding={{ base: '0px', md: '10px' }} border={'1px solid #e0e0e0'}>
        <Controller
          control={control}
          name={'tag_id'}
          defaultValue={slectedTagId}
          as={
            <TagsList
              showSearch
              listHeight={listHeight}
              initialSelectedIds={[slectedTagId]}
              selectionMode={SelectionMode.SINGLE}
              onSelectionChange={handleTagsSelectionChange}
            />
          }
        />
      </Box>
    </StyledFormControl>
  )
}
